import styled, { css } from 'styled-components';

const Label = styled.label`
  display: block;
  margin-bottom: .25rem;
  font-size: .75rem;
  font-weight: 600;


  ${props => props.hideLabel && css`
    position: absolute;
    pointer-events: none;
    clip: rect(0 0 0 0);
    overflow: hidden;
  `}
`;

export default Label;
